import type {SlackAlertType} from "@/pages/integrations/edit/subForms/slackInfo.ts";

export interface SlackAlertMock {
  checkName: string;
  monitoredUrl: string;
  tags: string[];
  reason: string;
  recoveredAfter: string;
  location: string;
  incidentId: string;
  moreInfoUrl: string;
  realtimeAnalysisUrl: string;
  notes: string;
  timestamp: string;
}

const COMMON: Omit<SlackAlertMock, "reason" | "recoveredAfter" | "timestamp"> = {
  checkName: "Example Check",
  monitoredUrl: "https://example.com",
  tags: ["production", "web"],
  location: "US East (Virginia)",
  incidentId: "",
  moreInfoUrl: "https://uptime.com/devices/services/details/1",
  realtimeAnalysisUrl: "https://uptime.com/devices/services/real-time-analysis/1",
  notes: "This is a simulated alert from the Test Integration dialog.",
};

export const SLACK_ALERT_MOCKS: Record<SlackAlertType, SlackAlertMock> = {
  down: {
    ...COMMON,
    reason: "Simulated failure: HTTP 503 Service Unavailable",
    recoveredAfter: "",
    timestamp: "10:42 AM",
  },
  up: {
    ...COMMON,
    reason: "",
    recoveredAfter: "4m 12s",
    timestamp: "10:46 AM",
  },
};
